import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  switchContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  switchLabel: {
    marginRight: 5
  },
  checkbox: {
    height: 0,
    width: 0,
    display: 'none',
    '&:checked + $label $button': {
      left: 'calc(100% - 2px)',
      transform: 'translateX(-100%)'
    },
    '&:checked + $label': {
      background: 'var(--theme-action-sec-fg)',
      border: '1px solid var(--theme-action-sec-bdr)'
    },
    '&:checked + $miniLabel $miniButton': {
      left: 'calc(100% - 2px)',
      transform: 'translateX(-100%)'
    },
    '&:checked + $miniLabel': {
      background: 'var(--theme-action-sec-fg)'
    },
    '&:disabled + $miniLabel': {
      background: 'var(--theme-brand-lightGray)'
    },
    '&:disabled': {
      '&:checked + $miniLabel': {
        background: 'var(--theme-brand-lightGray)'
      }
    }
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    width: 50,
    height: 26,
    background: 'var(--theme-brand-mediumGray)',
    borderRadius: 100,
    border: '1px solid var(--theme-brand-mediumGray)',
    position: 'relative',
    transition: 'background-color .2s',
    '&:active $button': {
      width: 30
    }
  },
  button: {
    content: '',
    position: 'absolute',
    top: 2,
    left: 2,
    width: 20,
    height: 21,
    borderRadius: 25,
    transition: '0.2s',
    background: '#fff'
  },
  miniSwitchLabel: {
    extend: 'switchLabel',
    fontSize: 14
  },
  miniLabel: {
    extend: 'label',
    height: 20,
    width: 34
  },
  miniButton: {
    extend: 'button',
    width: 16,
    height: 16
  }
}

export const useStyles = createUseStyles(style)
